module.exports = __webpack_public_path__ + "static/media/contactUs.c5aa4fe7.png";